"use client";

import React from "react";
import styles from "./home-hero.module.css";
import { Link } from "@/i18n/navigation";
import { CircleFlag } from "react-circle-flags";
import { KeyboardArrowRight } from "@mui/icons-material";
import HomeSearchbar from "@/components/searchbars/home-searchbar";
import { MdArrowForward, MdOutlineCheckCircle } from "react-icons/md";
// import HomeMobileSearchbar from "@/components/searchbars/home-mobile-searchbar";

interface HomeHeroProps {
  isGlobalMode: boolean;
  marketName: string;
  marketHost: string;
  marketCountryCode: string | null;
  heroImage: string;
  lat: string | null;
  long: string | null;
}

export default function HomeHero({
  isGlobalMode,
  marketName,
  marketHost,
  marketCountryCode,
  heroImage,
  lat,
  long,
}: HomeHeroProps) {
  return (
    <section className={styles.heroSection}>
      <div className={styles.heroBackground}></div>

      <div className={styles.heroContent}>
        {/* LEFT: Titles & Search */}
        <div className={styles.heroLeft}>
          {isGlobalMode ? (
            <>
              <h1 className={styles.heroTitle}>
                The world's properties.
                <br />
                One place to call home.
              </h1>
              <p className={styles.heroSubtitle}>
                From cozy apartments to iconic estates,
                <br />
                find your perfect property, anywhere in the world.
              </p>
            </>
          ) : (
            <>
              <h1 className={styles.heroTitle}>
                Discover properties
                <br />
                in {marketName}.
              </h1>
              <p className={styles.heroSubtitle}>
                Find your perfect home, investment, or commercial
                <br />
                space in the best local markets.
              </p>
            </>
          )}

          <div className={styles.searchContainer}>
            {/* <HomeMobileSearchbar lat={lat} long={long} /> */}
            <HomeSearchbar lat={lat} long={long} />

            {/* POPULAR TAGS */}
            <div className={styles.popularTags}>
              <span className={styles.popularLabel}>Popular:</span>
              <button className={styles.tagBtn}>Bucharest</button>
              <button className={styles.tagBtn}>Barcelona</button>
              <button className={styles.tagBtn}>Dubai</button>
              <button className={styles.tagBtn}>Miami</button>
              <button className={styles.tagBtn}>Paris</button>
            </div>
          </div>
        </div>

        {/* RIGHT: Global Hub Card */}
        <div className={styles.heroRight}>
          {isGlobalMode ? (
            /* --- GLOBAL HUB CARD --- */
            <div className={styles.hubCard}>
              <div className={styles.hubHeader}>
                <h3 className={styles.hubTitle}>You're on doomum.com</h3>
                <p className={styles.hubDesc}>Explore properties worldwide.</p>
              </div>

              <hr className={styles.hubDivider} />

              <div className={styles.hubHeader}>
                <h3 className={styles.hubTitle}>Go local</h3>
                <p className={styles.hubDesc}>
                  Discover properties and
                  <br />
                  expert agents in your country.
                </p>
              </div>

              <div className={styles.hubList}>
                <Link href="/ro" className={styles.hubItem}>
                  <div className={styles.hubItemLeft}>
                    <CircleFlag countryCode="ro" className={styles.hubFlag} />
                    <span>Romania</span>
                  </div>
                  <div className={styles.hubItemRight}>
                    <span className={styles.hubUrl}>doomum.ro</span>
                    <KeyboardArrowRight className={styles.hubIcon} />
                  </div>
                </Link>
                <Link href="/es" className={styles.hubItem}>
                  <div className={styles.hubItemLeft}>
                    <CircleFlag countryCode="es" className={styles.hubFlag} />
                    <span>Spain</span>
                  </div>
                  <div className={styles.hubItemRight}>
                    <span className={styles.hubUrl}>doomum.es</span>
                    <KeyboardArrowRight className={styles.hubIcon} />
                  </div>
                </Link>
                <Link href="/it" className={styles.hubItem}>
                  <div className={styles.hubItemLeft}>
                    <CircleFlag countryCode="it" className={styles.hubFlag} />
                    <span>Italy</span>
                  </div>
                  <div className={styles.hubItemRight}>
                    <span className={styles.hubUrl}>doomum.it</span>
                    <KeyboardArrowRight className={styles.hubIcon} />
                  </div>
                </Link>
                <Link href="/us" className={styles.hubItem}>
                  <div className={styles.hubItemLeft}>
                    <CircleFlag countryCode="us" className={styles.hubFlag} />
                    <span>United States</span>
                  </div>
                  <div className={styles.hubItemRight}>
                    <span className={styles.hubUrl}>doomum.us</span>
                    <KeyboardArrowRight className={styles.hubIcon} />
                  </div>
                </Link>
              </div>

              <hr className={styles.hubDivider} />

              <Link href="/countries" className={styles.hubFooterLink}>
                <span>View all countries</span>
                <KeyboardArrowRight className={styles.hubIcon} />
              </Link>
            </div>
          ) : (
            /* --- LOCAL HUB CARD --- */
            <div className={styles.hubCard}>
              <div className={styles.localHubHeader}>
                <div className={styles.localHubHeaderLeft}>
                  {marketCountryCode && (
                    <CircleFlag
                      countryCode={marketCountryCode.toLowerCase()}
                      className={styles.hubFlag}
                    />
                  )}
                  <span className={styles.localHubCountry}>{marketName}</span>
                </div>
                <span className={styles.hubUrl}>{marketHost}</span>
              </div>

              <h3 className={styles.localHubTitle}>
                Ghidul tău local în imobiliare
              </h3>

              <ul className={styles.localHubFeatures}>
                <li>
                  <MdOutlineCheckCircle className={styles.checkIcon} />
                  <span>Peste 15,000 proprietăți verificate</span>
                </li>
                <li>
                  <MdOutlineCheckCircle className={styles.checkIcon} />
                  <span>Agenți locali de încredere</span>
                </li>
                <li>
                  <MdOutlineCheckCircle className={styles.checkIcon} />
                  <span>Informații de piață actualizate</span>
                </li>
              </ul>

              <Link href="/market-insights" className={styles.localHubBtn}>
                Despre piața imobiliară
                <MdArrowForward className={styles.btnIcon} />
              </Link>

              <hr className={styles.hubDivider} />

              <Link href="/" className={styles.hubFooterLink}>
                <span>Go Global</span>
                <KeyboardArrowRight className={styles.hubIcon} />
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
